module.exports = __webpack_public_path__ + "static/media/accounting_success.f260c2ea.png";